import Icon from '../components/Icon.vue'

Icon.register({
  'bezier-curve': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M368 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h96zM208 88v72c0 9.5 2.2 18.4 5.9 26.4-34.3 24.3-59.7 59.9-71 101.6h-49.4c13.7-64.7 54.2-119.5 109.5-152h-79.7c-9.5 23.4-32.4 40-59.3 40-35.3 0-64-28.7-64-64s28.7-64 64-64c26.8 0 49.8 16.6 59.3 40h84.8zM160 320c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h96zM576 48c35.3 0 64 28.7 64 64s-28.7 64-64 64c-26.8 0-49.8-16.6-59.3-40h-79.7c55.4 32.5 95.9 87.3 109.5 152h-49.4c-11.3-41.6-36.8-77.2-71-101.6 3.7-8.1 5.9-17 5.9-26.4v-72h84.8c9.5-23.4 32.4-40 59.3-40zM576 320c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h96z'
      }
    ]
  }
})
